import { uiText } from '@/i18n/interface';
import { supabase } from '@/integrations/supabase/client';

export function studentStatusError(error: { code?: string; message?: string }) {
  if (error.code === '42703' || error.code === 'PGRST204' || /is_active.*(exist|schema)|could not find.*is_active/i.test(error.message || '')) {
    return uiText("Student status is not configured in the database. Apply the student status setup migration, then try again.");
  }
  if (error.code === '42501') return uiText("Your account does not have permission to update this student.");
  return error.message || uiText("The student status could not be saved. Please try again.");
}

export async function saveStudentStatus(studentId: string, isActive: boolean) {
  const { data, error } = await supabase.from('profiles').update({ is_active: isActive })
    .eq('id', studentId).eq('role', 'student').select('*').single();
  if (error) throw new Error(studentStatusError(error));
  if (!data || data.is_active !== isActive) throw new Error(uiText("The database did not confirm the new student status."));
  return data.is_active;
}
